import PropTypes from 'prop-types'
import {Flex, Text} from '@chakra-ui/react'

import CopyButton from '../CopyButton'

const CopyField = ({title, value}) => (
  <Flex
    direction="column"
    p="sm"
    pr="xs"
    backgroundColor="mld.neutral.50"
    display="inline-flex"
  >
    <Text
      fontSize="14px"
      textTransform="uppercase"
      color="mld.neutral.1000"
      lineHeight="110%"
      letterSpacing="-1%"
      mb={1}
    >
      {title}
    </Text>
    <Flex alignItems="center" gap={2}>
      <Text fontSize="xl" letterSpacing="-4%">
        {value}
      </Text>
      <CopyButton content={value} label={`Copy ${title}`} />
    </Flex>
  </Flex>
)

CopyField.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export default CopyField
